export default {
  apiKey: 'AIzaSyD0-7n7VsoSHVAKEIHh6tynTYyqyvlC1_M',
  authDomain: 'nani-production.firebaseapp.com',
  projectId: 'nani-production',
  storageBucket: 'nani-production.firebasestorage.app',
  messagingSenderId: '588899234054',
  appId: '1:588899234054:web:dae25f03d1d1480c466e87',
};
